export type AppLocale = 'es' | 'en'

/** Preferencia persistida: automática o idioma fijo. */
export type LocalePreference = 'auto' | AppLocale

export const APP_LOCALES: readonly AppLocale[] = ['es', 'en']

export function isAppLocale(value: string): value is AppLocale {
  return value === 'es' || value === 'en'
}

export function isLocalePreference(value: string): value is LocalePreference {
  return value === 'auto' || isAppLocale(value)
}
